__turbopack_context__.v({
  "foo": "tmNsCa_foo",
  "passport_cta": "tmNsCa_passport_cta",
  "video_mezzanine_link_badge": "tmNsCa_video_mezzanine_link_badge",
  "video_mezzanine_link_now_playing": "tmNsCa_video_mezzanine_link_now_playing",
  "video_mezzanine_link_passport_badge": "tmNsCa_video_mezzanine_link_passport_badge",
  "video_mezzanine_link_wrapper": "tmNsCa_video_mezzanine_link_wrapper",
});
